import { type AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, type OnInit, ViewChild } from '@angular/core';
import type { Classes } from 'jss';
import { ColumnStructureEntity, SpecificBlocksEntity, SpecificSectionStructureEntity } from '@web/types';
import type { AnimationSettings } from '@components/sp-animation-settings/type/animation-settings.type';

import { ServerStylesService } from '@common/services/server-styles.service';

import { getStyles } from '@web/layout/content/page-content/components/columns/specific-column-wrapper/specific-column-wrapper.component.styles';
import { getGsapScrollTrigger } from '@components/sp-animation-settings';
import { CommonModule } from '@angular/common';
import { PlatformService } from '@common/services/platform.service';
import { TransferStateService } from '@web-builder/core/services/transfer-state.service';

@Component({
    selector: 'web-builder-specific-column-wrapper',
    templateUrl: './specific-column-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule],
})
export class SpecificColumnWrapperComponent implements OnInit, AfterViewInit {
    @ViewChild('animatedElem') animatedElem: ElementRef<HTMLDivElement>;

    @Input() public column!: ColumnStructureEntity;
    @Input() public columnSection!: SpecificSectionStructureEntity;
    @Input() public block!: SpecificBlocksEntity;
    @Input() public index!: number;

    public classes: Classes;
    public isBrowser: boolean = this.platformService.isPlatformBrowser();
    public isPreview: boolean = this.transferStateService.isPreview;
    public isEnabledAnimations: boolean = this.transferStateService.get('isEnabledAnimations');

    constructor(
        protected readonly stylesService: ServerStylesService,
        private readonly platformService: PlatformService,
        private readonly transferStateService: TransferStateService,
    ) {}

    public ngOnInit(): void {
        this.classes = this.stylesService.getStyles(this.column.id, getStyles(this.column, this.columnSection, this.block));
    }

    public ngAfterViewInit(): void {
        const animationOptions = this.column.data.animation;
        if (animationOptions?.isActive)
            getGsapScrollTrigger(
                animationOptions,
                this.animatedElem.nativeElement,
                this.isBrowser,
                null,
                this.isPreview,
                this.isEnabledAnimations,
            );
    }

    public get animation(): AnimationSettings {
        return this.column.data.animation;
    }

    public get columnId(): string {
        return `column-${this.column.id}`;
    }
}
